// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics__keyValue {
    display: flex;
    align-items: center;
    margin: 25px 0;
}

.statistics__minMaxAv__bar {
    background: #1faeff;
    border-radius: 15px;
    position: relative;
    width: 300px;
    height: 30px;
    margin: 0 10px;
}

.statistics__minMaxAv__average {
    position: absolute;
    background: #fff;
    height: 30px;
    width: 5px;
}

.statistics__minMaxAv__dataLabel {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    width: 50px;
}

.statistics__minMaxAv__dataLabel span {
    text-transform: none;
    font-size: 25px;
    color: #1faeff;
}

.statistics__minMaxAv__range::before {
    content: attr('min');
    position: absolute;
    top: 30px;
    left: 0;
    display: block;
}

.statistics__field {
    font-size: 20px;
    margin-right: 10px;
    width: 200px;
}

.statistics__field::after {
    content: ': ';
    position: relative;
}

.statistics__value {
    color: #1faeff;
    font-size: 25px;
}

.statistics__tag {
    color: inherit;
    margin: 0 3px;
    text-decoration-style: dashed;
    text-decoration-thickness: 2px;
    font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/statistics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,8BAA8B;IAC9B,eAAe;AACnB","sourcesContent":[".statistics__keyValue {\n    display: flex;\n    align-items: center;\n    margin: 25px 0;\n}\n\n.statistics__minMaxAv__bar {\n    background: #1faeff;\n    border-radius: 15px;\n    position: relative;\n    width: 300px;\n    height: 30px;\n    margin: 0 10px;\n}\n\n.statistics__minMaxAv__average {\n    position: absolute;\n    background: #fff;\n    height: 30px;\n    width: 5px;\n}\n\n.statistics__minMaxAv__dataLabel {\n    font-size: 14px;\n    display: flex;\n    flex-direction: column;\n    width: 50px;\n}\n\n.statistics__minMaxAv__dataLabel span {\n    text-transform: none;\n    font-size: 25px;\n    color: #1faeff;\n}\n\n.statistics__minMaxAv__range::before {\n    content: attr('min');\n    position: absolute;\n    top: 30px;\n    left: 0;\n    display: block;\n}\n\n.statistics__field {\n    font-size: 20px;\n    margin-right: 10px;\n    width: 200px;\n}\n\n.statistics__field::after {\n    content: ': ';\n    position: relative;\n}\n\n.statistics__value {\n    color: #1faeff;\n    font-size: 25px;\n}\n\n.statistics__tag {\n    color: inherit;\n    margin: 0 3px;\n    text-decoration-style: dashed;\n    text-decoration-thickness: 2px;\n    font-size: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
